export default __webpack_public_path__ + "static/faqs-6ededa940526b43cdc5de6de6b204c79.png";